class BESSAppProjectEnergyNonResBuildingProfileEditorManager extends BESSAppProjectEditorManagerBase {

    constructor(editor) {
        super(editor);
    }

    manageItem(item) {
        projectInputsAreRequiredIfOthersHaveEntry([
            item.inputs.heatingCoolingComfortVentilationElectricityReferenceFabricAndReferenceServices,
            item.inputs.heatingCoolingComfortVentilationElectricityProposedFabricAndProposedServices,
            item.inputs.heatingCoolingComfortVentilationElectricityProposedFabricAndReferenceServices,]
        );

        projectInputsAreRequiredIfOthersHaveEntry([
            item.inputs.heatingWoodReferenceFabricAndReferenceServices,
            item.inputs.heatingWoodProposedFabricAndProposedServices,
            item.inputs.heatingWoodProposedFabricAndReferenceServices,]
        );

        projectInputsAreRequiredIfOthersHaveEntry([
            item.inputs.peakThermalCoolingLoadBaseline,
            item.inputs.peakThermalCoolingLoadProposed,]
        );

        projectInputIsRequiredIfOthersHasEntry(
            item.inputs.hotWaterElectricityBaseline,
            [
                item.inputs.hotWaterGasBaseline,
                item.inputs.hotWaterGasProposed,
            ]
        );

        projectInputIsRequiredIfOthersHasEntry(
            item.inputs.hotWaterElectricityProposed,
            [
                item.inputs.hotWaterGasBaseline,
                item.inputs.hotWaterGasProposed,
            ]
        );

        projectInputIsRequiredIfOthersHasEntry(
            item.inputs.hotWaterGasBaseline,
            [
                item.inputs.hotWaterElectricityBaseline,
                item.inputs.hotWaterElectricityProposed,
            ]
        );

        projectInputIsRequiredIfOthersHasEntry(
            item.inputs.hotWaterGasProposed,
            [
                item.inputs.hotWaterElectricityBaseline,
                item.inputs.hotWaterElectricityProposed,
            ]
        );

    }
}